import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useRouteError } from 'react-router-dom';
import ServerDown from '../../../assets/svg/server_down.svg';
import { Grid } from '@mui/material';
import { gridSizeMdLg12 } from '@/shared/constants/ui.constants';
import { GLOBAL_LABELS } from '@/shared/constants/ui/app.constants';

export default function ErrorPagina(): React.JSX.Element {
  const error: any = useRouteError();

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      height: "100vh"
    }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          padding: { xs: '20px', sm: '40px', md: '80px', lg: '100px' },
        }}
        spacing={2}
      >
        <Grid item {...gridSizeMdLg12} textAlign={'center'}>
          <Box
            component="img"
            alt="Under development"
            src={ServerDown}
            sx={{
              display: 'inline-block',
              height: 'auto',
              maxWidth: '100%',
              width: { xs: '300px', sm: '300px', md: '400px' }
            }}
          />
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          <Typography variant="h4" sx={{ textAlign: 'center', fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' } }}>
            Oops!
          </Typography>
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          <Typography color="text.secondary" variant="body1" sx={{ textAlign: 'center', fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' } }}>
            Nuestro sitio está resolviendo el siguiente detalle "{error.statusText || error.message}".
            ¡Aprovecha este momento perfecto para recargar energías! Pronto estaremos listos para
            volver y mejorar la experiencia de {GLOBAL_LABELS.APP_TITLE}.
          </Typography>
        </Grid>

        <Grid item {...gridSizeMdLg12} textAlign={'center'}>
          <Button
            variant="contained"
            onClick={() => {
              window.history.back();
            }}
            sx={{
              fontSize: { xs: '0.8rem', sm: '1rem' },
              padding: { xs: '6px 12px', sm: '8px 16px' },
            }}
          >
            Regresar
          </Button>
        </Grid>
      </Grid>

    </div>
  );
}
